import Image from "next/image";
import Link from "next/link";
import { getDomain } from "tldts";

import localise from "@/components/localise";

import { Card, CardContent } from "@/components/ui/card";

const PartnerCard = ({ partner }) => (
  <Card className="relative transition-transform duration-150 ease-in-out hover:transform hover:-translate-y-1">
    <CardContent className="flex items-center space-x-4 p-2 lg:p-4">
      <div className="sm:shrink-0 bg-white rounded-lg p-1 lg:p-2">
        {partner.logo && (
          <Image
            src={partner.logo}
            alt={localise("common.partnerLogoImageAlt", {
              title: partner.title,
            })}
            width={640}
            height={360}
            className="w-14 lg:w-20 h-12 object-contain"
          />
        )}
      </div>
      <div className="sm:min-w-0 sm:flex-1">
        <Link
          href={localise("links.shop", { slug: partner.slug })}
          className="focus:outline-none"
        >
          <span aria-hidden="true" className="absolute inset-0"></span>
          <h3 className="truncate font-bold">{partner.title}</h3>
          {partner.domain && (
            <div className="text-gray-500">{getDomain(partner.domain)}</div>
          )}
        </Link>
      </div>
    </CardContent>
  </Card>
);

export default PartnerCard;
